import Vue from 'vue'
import Router from 'vue-router'
import TokenService from '@/common/token.service.js'
import * as CONSTANTS from '@/store/constants.js'
import store from '@/store/index.js'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: { name: 'start' },
            meta: {
                requiresAuth: false
            },
        },{
            path: '/tables',
            name: 'tables',
            props: true,
            redirect: { name: 'tables.layout' },
            meta: {
                requiresAuth: true,
                order: true,
                requiresRoles: [
                    CONSTANTS.ROLE_MANAGER,
                    CONSTANTS.ROLE_CASHIER
                ]
            },
            component: () => import('./views/Tables.vue'),
            children: [{
                path: 'layout/:layout_id?',
                name: 'tables.layout',
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Tables/Layout.vue'),
            },{
                path: 'table/:table_id',
                name: 'tables.details',
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Tables/Details.vue'),
            }]
        },{
            path: '/pos',
            name: 'pos',
            props: true,
            redirect: { name: 'pos.categories' },
            meta: {
                requiresAuth: true,
                order: true,
                requiresRoles: [
                    CONSTANTS.ROLE_MANAGER,
                    CONSTANTS.ROLE_CASHIER
                ]
            },
            component: () => import('./views/Pos.vue'),
            children: [{
                path: '',
                redirect: 'categories'
            },{
                path: 'categories',
                name: 'pos.categories',
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Categories.vue'),
            },{
                path: 'products/:category_id',
                name: 'pos.products',
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Products.vue'),
            },{
                path: 'info/:product_id',
                name: 'pos.product.info',
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Info.vue'),
            },{
                path: 'payment',
                name: 'pos.payment',
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Payment.vue'),
            },{
                path: 'customer',
                name: 'pos.customer.info',
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Customer.vue'),
            },{
                path: 'cash',
                name: 'pos.payment.cash',
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Payment/Cash.vue'),
            },{
                path: 'card',
                name: 'pos.payment.card',
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Payment/Card.vue'),
            },{
                path: 'credit',
                name: 'pos.payment.credit',
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Payment/Credit.vue'),
            },{
                path: 'voucher',
                name: 'pos.payment.voucher',
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Payment/Voucher.vue'),
            },{
                path: 'subvention',
                name: 'pos.payment.subvention',
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Payment/Subvention.vue'),
            },{
                path: 'change',
                name: 'pos.payment.change',
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Payment/Change.vue'),
            },{
                path: 'orders',
                name: 'pos.orders',
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Orders.vue')
            },{
                path: 'tables',
                name: 'pos.tables',
                meta: {
                    requiresAuth: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Tables.vue')
            },{
                path: 'customers',
                name: 'pos.customers',
                meta: {
                    requiresAuth: true,
                    order: false,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Customers.vue')
            },{
                path: 'search',
                name: 'pos.search',
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Search.vue')
            },{
                path: 'builder/:category_id/:item_id',
                name: 'pos.builder',
                redirect: { name: 'pos.builder.categories' },
                props: true,
                meta: {
                    requiresAuth: true,
                    order: true,
                    requiresRoles: [
                        CONSTANTS.ROLE_MANAGER,
                        CONSTANTS.ROLE_CASHIER
                    ]
                },
                component: () => import('./views/Pos/Builder.vue'),
                children: [{
                    path: 'categories',
                    name: 'pos.builder.categories',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        order: true,
                        requiresRoles: [
                            CONSTANTS.ROLE_MANAGER,
                            CONSTANTS.ROLE_CASHIER
                        ]
                    },
                    component: () => import('./views/Pos/Builder/Categories.vue'),
                }, {
                    path: 'products/:builder_category_id',
                    name: 'pos.builder.products',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        order: true,
                        requiresRoles: [
                            CONSTANTS.ROLE_MANAGER,
                            CONSTANTS.ROLE_CASHIER
                        ]
                    },
                    component: () => import('./views/Pos/Builder/Products.vue')
                }],
            }]
        },
        /***
        * Local login disabled
        */
        // {
        //   path: '/login',
        //   name: 'login',
        //   meta: {
        //     requiresAuth: false,
        //     requiresRoles: []
        //   },
        //   component: () => import('./views/Login.vue')
        // },
        {
            path: '/about',
            name: 'about',
            meta: {
                requiresAuth: false,
                requiresRoles: []
            },
            component: () => import('./views/About.vue')
        },{
            path: '/start',
            name: 'start',
            meta: {
                requiresAuth: true,
                order: true,
                requiresRoles: [
                    CONSTANTS.ROLE_MANAGER,
                    CONSTANTS.ROLE_CASHIER
                ]
            },
            component: () => import('./views/Start.vue')
        },{
            path: '/preview',
            name: 'preview',
            meta: {
                requiresAuth: true,
                order: true,
                requiresRoles: [
                    CONSTANTS.ROLE_MANAGER,
                    CONSTANTS.ROLE_CASHIER
                ]
            },
            component: () => import('./views/Preview.vue')
        },{
            path: '/checkin',
            name: 'checkin',
            meta: {
                requiresAuth: true,
                order: true,
                requiresRoles: [
                    CONSTANTS.ROLE_MANAGER,
                    CONSTANTS.ROLE_CASHIER
                ]
            },
            component: () => import('./views/Checkin.vue')
        }
    ]
})

router.beforeEach((to, from, next) => {
    if(! to.meta.requiresAuth) {
        return next();
    }
    const loggedIn = !!TokenService.get();
    const role = !!TokenService.getRole();

    if (!loggedIn || !role || !to.meta.requiresRoles.includes(Number(TokenService.getRole()))) {
        TokenService.removeAll();
        window.location.href = process.env.VUE_APP_URL_AUTH;
    } else {
        next();
    }
});

router.afterEach(() => {
    store.commit('general/mobileOrderExpanded', false)
    document.body.classList.remove('modal-on')
});

export default router;
